<template>
	<div class="alterar-classificacao-itens-ata">
		<v-row class="mt-3">
			<v-col cols="12" sm="2" md="2" lg="2" xl="2" class="py-1">
				<span class="font-weight-bold">
					<label-personalizado nome-campo="Item"></label-personalizado>
				</span>
				<span>{{ itemSelecionado.item }}</span>
			</v-col>
			<v-col cols="12" sm="4" md="4" lg="4" xl="4" class="py-1">
				<span class="font-weight-bold">
					<label-personalizado nome-campo="Tipo"></label-personalizado>
				</span>
				<span>{{ itemSelecionado.tipo }}</span>
			</v-col>
			<v-col cols="12" sm="6" md="6" lg="6" xl="6" class="py-1">
				<span class="font-weight-bold">
					<label-personalizado nome-campo="Descrição"></label-personalizado>
				</span>
				<texto-tooltip
					:texto="itemSelecionado.descricao"
					:tamanho-maximo="textoDescricaoCompletaItemLimite"
				></texto-tooltip>
			</v-col>
		</v-row>
		<v-divider class="mb-1 mt-3"></v-divider>
		<div v-if="hasItens">
			<v-data-table
				:headers="headers"
				:items="datasource"
				:server-items-length="totalItens"
				:loading="carregando"
				item-key="id"
				hide-default-footer
				dense
				class="arp-listview row-pointer"
			>
				<template #body="{ items }">
					<tbody>
						<tr v-for="item in items" :key="item.id">
							<td class="text-xs-left">
								<texto-tooltip
									:texto="item.razaoSocial"
									:tamanho-maximo="textoRazaoSocialLimite"
								></texto-tooltip>
							</td>
							<td class="text-xs-left">
								<texto-tooltip :texto="item.marca" :tamanho-maximo="textoMarcaLimite"></texto-tooltip>
							</td>
							<td class="text-xs-left">
								<span>{{ item.valorUnitario | azCurrency(numeroCasasDecimaisValores) }}</span>
							</td>
							<td class="text-xs-left">
								<div>
									<v-text-field
										v-model="item.classificacao"
										class="alterar-classificacao-itens-ata__input"
										:rules="rulesClassificacao"
										type="number"
										:min="min"
										:max="max"
										ref="justificativa"
										dense
										flat
										append-outer-icon=" "
										@keyup="setClassificacao(item)"
									></v-text-field>
								</div>
							</td>
						</tr>
					</tbody>
				</template>
			</v-data-table>
			<paginacao-tabela
				:total-paginas="totalPaginas"
				:total-itens="totalItens"
				:page.sync="paginacao.page"
				:rows-per-page.sync="paginacao.rowsPerPage"
				@resetar-page="$emit('reset-page')"
				@paginar="setPaginacao"
				:class="{ 'mb-8': totalItens >= 5 }"
			></paginacao-tabela>
			<v-form ref="justificativaForm" lazy-validation>
				<label-personalizado
					nome-campo="Motivo"
					obrigatorio-por-padrao
					class="label-motivo"
				></label-personalizado>
				<v-textarea
					id="justificativa"
					v-model="justificativa"
					:rules="regrasMotivo"
					rows="2"
					class="ma-0 py-0"
					:max="limiteCaracteresJustificativa"
					:counter="limiteCaracteresJustificativa"
					placeholder="Informe os motivos da mudança de classificação"
					no-resize
					@input="corrigirTexto"
				></v-textarea>
			</v-form>
		</div>

		<template-listagem-vazia
			:textos="textosListagemVazia"
			:total-itens="totalItens"
			:length="1"
		></template-listagem-vazia>
	</div>
</template>

<script>
import { mutationTypes } from '@/core/constants'
import { TabelaColunaUtils } from '@/core/utils'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'
import { mapState } from 'vuex'

export default {
	name: 'alterar-classificacao',
	mixins: [validacaoFormulario],
	props: {
		itemSelecionado: {
			type: Object,
			default: () => {
				return {
					isBloqueado: false,
				}
			},
		},
		limiteCaracteresJustificativa: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {
			headers: [
				new TabelaColunaUtils('Razão Social', 'razaoSocial', '30%'),
				new TabelaColunaUtils('Marca', 'marca', '30%'),
				new TabelaColunaUtils('Preço', 'preco', '25%'),
				new TabelaColunaUtils('Classificação', 'classificacao', '15%'),
			],
			rulesClassificacao: [(value) => this.regraObrigatoriedade(value, 'Campo obrigatório.')],
			regrasMotivo: [
				(value) => this.regraObrigatoriedade(value, 'O motivo é obrigatório.'),
				(value) =>
					this.regraDeTamanhoMaximoString(
						value,
						this.limiteCaracteresJustificativa,
						`O campo de motivo deve ser igual ou menor que ${this.limiteCaracteresJustificativa} caracteres!`,
					),
			],
			textoDescricaoCompletaItemLimite: 150,
			textoMarcaLimite: 80,
			textoRazaoSocialLimite: 60,
			textosListagemVazia: {
				titulo: 'Não há fornecedores classificados por aqui',
			},
			carregando: false,
		}
	},
	computed: {
		...mapState({
			paginacao: (state) => state.itemAta.alterarClassificacao.alterar.paginacao,
			datasource: (state) => state.itemAta.alterarClassificacao.alterar.datasource,
			totalItens: (state) => state.itemAta.alterarClassificacao.alterar.totalElements,
			totalPaginas: (state) => state.itemAta.alterarClassificacao.alterar.totalPages,
			min: (state) => state.itemAta.alterarClassificacao.alterar.faixaMinClassificacao,
			max: (state) => state.itemAta.alterarClassificacao.alterar.faixaMaxClassificacao,
		}),
		numeroCasasDecimaisValores: {
			get() {
				return this.$store.state.ata.informacoesAta.numeroCasasDecimaisValores
			},
		},
		justificativa: {
			get() {
				return this.$store.state.itemAta.alterarClassificacao.alterar.justificativa
			},
			set(justificativa) {
				this.$store.commit(
					mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.ALTERAR.SET_JUSTIFICATIVA,
					justificativa,
				)
			},
		},
		hasItens() {
			return this.totalItens > 1
		},
	},
	watch: {
		paginacao: {
			handler(novoValor) {
				this.setPaginacao(novoValor)
			},
			deep: true,
		},
	},
	beforeDestroy() {
		this.$store.commit(mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.ALTERAR.RESET_ALTERACOES_CLASSIFICACAO)
		this.$store.commit(mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.ALTERAR.RESETAR_PAGINA_LISTAGEM)
		this.$store.commit(mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.ALTERAR.RESET_JUSTIFICATIVA)
		this.$store.commit(mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.ALTERAR.RESET_DATASOURCE)
	},
	async mounted() {
		this.carregando = true
		await this.carregarFornecedores()
		this.carregando = false
	},
	methods: {
		async carregarFornecedores() {
			await this.$emit('carregar-fornecedores')
		},
		setPaginacao(paginacao) {
			this.$store.commit(mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.ALTERAR.SET_PAGINACAO_LISTAGEM, paginacao)
			this.carregarFornecedores()
		},
		setClassificacao(item) {
			const valor = parseInt(item.classificacao)

			if (this.validarFaixaDoValor(valor)) {
				if (valor) {
					this.$set(item, '_classificacao', valor)
				}

				this.$set(item, 'classificacao', valor)
			} else {
				this.$set(item, 'classificacao', parseInt(item._classificacao))
			}
		},
		validarFaixaDoValor(valor) {
			return (valor >= this.min && valor <= this.max) || !valor
		},
		corrigirTexto() {
			if (this.justificativa) this.justificativa = this.justificativa.trim()
		},
	},
}
</script>

<style lang="stylus">
.alterar-classificacao-itens-ata {

	.label-motivo {
		margin-top: (-36 / 16)rem !important
	}

	.alterar-classificacao-itens-ata__input {
		min-height (35 / 16)rem !important
		max-width 80% !important
		min-width 36% !important
		font-size (13 / 16)rem !important
		align-items center
		text-align-last center
		padding 0 !important

		.v-input input {
			max-height (24 / 16)rem !important
		}

		.v-input__slot {
			margin-bottom 0 !important
		}

		.v-text-field__slot input {
			padding: 0 !important
		}

		.v-messages__message {
			text-align center
			line-height 1rem !important
		}

		.v-input__icon--append-outer:after {
			content: "Lugar"
			font-size: (12 / 16)rem !important
			margin-left: (4 / 16)rem !important
		}
	}
}
</style>
